import * as React from 'react';
import icon from '../../assets/img/flags/guam.svg';

export const Guam = (props) => <img src={icon} height={props.height || 100} alt="Flag" />;
